import { Injectable, inject, PLATFORM_ID, signal, linkedSignal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private _platformId = inject(PLATFORM_ID);
  private _router = inject(Router);

  activeSection = linkedSignal<string>(() => {
    if (isPlatformBrowser(this._platformId)) {
      const url = this._router.url;
      if (url === '/' || url === '/#') {
        return 'home';
      }
    }
    return '';
  });

  scrollToSection(id: string) {
    if (isPlatformBrowser(this._platformId)) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
        this.activeSection.set(id);
      }
    }
  }
}
